/**
 * Gets environment specific values. Only used in Forte payment.
 * @returns {{url: string, key: string}}
 * Forte.js ~ https://www.forte.net/devdocs/forte.js/forte.js.htm
 */
export default function getForteConfig() {
  if (window.config.ENVIRONMENT === 'production'
    && window.location.hostname === 'ridmvservices.ri.gov') {
    return {
      url: 'https://api.forte.net/js/v1',
      key: '5D21242513'
    };
  }
  return {
    url: 'https://sandbox.forte.net/api/js/v1',
    key: 'C0F14C8685'
  };
}
